import authenticationApi from '../api/budgetAuthenticationApi';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';
import localStorageProvider from '../utils/localStorageProvider';
import config from '../config';

export const types = {
  BUDGET_UPDATE_ACCOUNT: 'BUDGET_UPDATE_ACCOUNT',
  BUDGET_UPDATE_ACCOUNT_SUCCESS: 'BUDGET_UPDATE_ACCOUNT_SUCCESS',
  BUDGET_UPDATE_ACCOUNT_FAILURE: 'BUDGET_UPDATE_ACCOUNT_FAILURE',
  BUDGET_UPDATE_SETTINGS: 'BUDGET_UPDATE_SETTINGS',
  BUDGET_UPDATE_SETTINGS_SUCCESS: 'BUDGET_UPDATE_SETTINGS_SUCCESS',
  BUDGET_UPDATE_SETTINGS_FAILURE: 'BUDGET_UPDATE_SETTINGS_FAILURE',
  BUDGET_DELETE_ACCOUNT: 'BUDGET_DELETE_ACCOUNT',
  BUDGET_DELETE_ACCOUNT_SUCCESS: 'BUDGET_DELETE_ACCOUNT_SUCCESS',
  BUDGET_DELETE_ACCOUNT_FAILURE: 'BUDGET_DELETE_ACCOUNT_FAILURE',
};

export const actions = {
  updateUserProfile: data => dispatch => {
    return authenticationApi
      .updateProfile(data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.BUDGET_UPDATE_ACCOUNT_SUCCESS, data });
          dispatch(notificationActions.showSuccess('Zaktualizowano konto użytkownika'));
          return true;
        } else {
          dispatch({ type: types.BUDGET_UPDATE_ACCOUNT_FAILURE });
          dispatch(notificationActions.showError('Nie udało się zaktualizować konta użytkownika'));
          logger.error(response.data);
        }
      });
  },  
  updateSettings: data => dispatch => {
    return authenticationApi
      .updateSettings(data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.BUDGET_UPDATE_SETTINGS_SUCCESS, data });
          dispatch(notificationActions.showSuccess('Zaktualizowano ustawienia użytkownika'));
          return true;
        } else {
          dispatch({ type: types.BUDGET_UPDATE_SETTINGS_FAILURE });
          dispatch(notificationActions.showError('Nie udało się zaktualizować ustawień użytkownika'));
          logger.error(response.data);
        }
      });
  },
  deleteAccount: () => dispatch => {
    return authenticationApi
    .deleteAccountByParticipant()
    .then(response => {
      if (response.ok) {
        localStorageProvider.removeItem(config.BUDGET_AUTH_STATE_ITEM_NAME);

        dispatch({ type: types.BUDGET_DELETE_ACCOUNT_SUCCESS});
        dispatch(notificationActions.showSuccess('Usunięto konto użytkownika'));
        return true;
      } else {
        dispatch({ type: types.BUDGET_DELETE_ACCOUNT_FAILURE });
        dispatch(notificationActions.showError('Nie udało się usunąć konta użytkownika'));
        logger.error(response.data);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/budgetAccountsActions.js